import {useEffect} from "react";
import { Link, useParams } from "react-router-dom";
import {useMutation, useQuery} from "@apollo/client";
import { ErrorBoundary } from "react-error-boundary";
import EventsSlideShow from "./EventsSlideShow";
import Footer from "../../components/Footer";
import {GET_EVENT_BY_URL} from "../../server/graphql/queries";
import ErrorFallback from "../../components/ErrorFallback";
import CreateUserBannerForm from "./CreateUserBanner";
import {classNames} from "../../helpers";
import typography from "../../helpers/typography";
import {INCREMENT_EVENT_FIELDS} from "../../server/graphql/mutations/events";

const Show = () => {
  const { eventUrl } = useParams();
  const [incrementEvent] = useMutation(INCREMENT_EVENT_FIELDS);
  const { data, error, loading, refetch } = useQuery(GET_EVENT_BY_URL, {
    variables: { eventUrl },
  });
  const currentEvent = data?.eventByUrl ?? {};

  useEffect(() => {
    if (data?.eventByUrl) {
      incrementEvent({ variables: {
          uuid: currentEvent.uuid,
          fields: [ 'numberOfViews' ]
        } });
    }
  }, [loading]);

  const getBgHeroImage = () => {
    let bg = 'bg-hero-pattern';
    if (currentEvent?.title && currentEvent.title.toLowerCase().includes('reboot')) {
      bg = 'bg-reboot-camp';
    }
    // TODO revisit this later
    // if (currentEvent?.imageUrl) {
    //   bg = "bg-[url(" + currentEvent.imageUrl + ")]";
    // }
    return bg;
  }

  return (
    <div>
      <div className="relative">
        <div className={classNames("bg-slate-400 w-full h-40 md:h-80 bg-center bg-no-repeat bg-cover", getBgHeroImage())}>
          <div className={classNames(currentEvent?.imageUrl ? "backdrop-blur-[3px]" : "backdrop-blur-sm", "h-full w-full")}></div>
        </div>
        <div className="border border-artfulRed h-fit md:w-11/12 mx-auto max-w-[960px] border-t-0">
          {/* banner form */}
          <ErrorBoundary
            FallbackComponent={ErrorFallback}
            onReset={() => refetch()}
            resetKeys={[currentEvent, eventUrl]}
          >
            <CreateUserBannerForm
              key={currentEvent.uuid}
              error={error}
              loading={loading}
              currentEvent={currentEvent}
            />
          </ErrorBoundary>
        </div>

        <div className="w-11/12 mx-auto mb-8 mt-5 max-w-[960px] font-lato">
          <h4
            className={classNames(
              typography.sizes.h4,
              "text-center font-poppins font-medium mt-20 mb-12 pl-6"
            )}>
            Latest Events
          </h4>

          <EventsSlideShow />

          <Link
            className="text-artfulRed underline underline-offset-4 mt-8 block text-center"
            to="/"
          >
            Back to home
          </Link>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Show;
